import { createContext, useContext } from "react";

export const PortalContainer = createContext<HTMLElement | null>(null);

export const usePortalContainer = (override?: HTMLElement | null) => {
  const inherited = useContext(PortalContainer);
  return (override ?? inherited) || undefined;
};
